import { render } from "./SignUpFinishView.vue?vue&type=template&id=596f3baa&scoped=true"
import script from "./SignUpFinishView.vue?vue&type=script&lang=js"
export * from "./SignUpFinishView.vue?vue&type=script&lang=js"

import "./SignUpFinishView.vue?vue&type=style&index=0&id=596f3baa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596f3baa"]])

export default __exports__